<vdr-card
  *ngIf="visibility$ | async"
  [title]="'link.event' | translate"
  style="margin-bottom: 1rem"
>
  <div cdkDropList (cdkDropListDropped)="moveListItem($event)">
    <div
      class="list-item-row"
      *ngFor="let item of listItems; trackBy: trackById"
      cdkDrag
      [cdkDragData]="item"
      [cdkDragLockAxis]="'y'"
    >
      <div class="flex-spacer pr-2">
        <vdr-card>
          <div
            style="display: flex; justify-content: space-between; width: 100%"
          >
            <div>{{ item.name }}</div>
            <div style="display: flex">
              <div>{{ item.startDate | localeDate : "short" }}</div>
              <div style="margin-left: 6px; margin-right: 6px">to</div>
              <div>{{ item.endDate | localeDate : "short" }}</div>
            </div>
          </div>
        </vdr-card>
      </div>
      <button
        class="button-small"
        *ngIf="!readonly"
        (click)="removeListItem(item)"
        [title]="'common.remove-item-from-list' | translate"
      >
        <clr-icon shape="times"></clr-icon>
      </button>
      <!-- <div class="drag-handle" cdkDragHandle [class.hidden]="readonly">
        <clr-icon shape="drag-handle" size="24"></clr-icon>
      </div> -->
    </div>
    <button
      class="btn btn-primary btn-sm"
      (click)="addListItem()"
      *ngIf="listItems.length <= 0"
    >
      <clr-icon shape="plus"></clr-icon>
      {{ "catalog.add-event" | translate }}
    </button>
  </div>
</vdr-card>
